import axios from "axios";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import bilAPI from "../../services/api";
import { BASE_URL } from "../constants/constants.js";
import { UserContext } from "../contexts/UserContext";
import TokenService from "../../services/token.service.js";

export default function useAuth() {
  const navigate = useNavigate();

  const { user, setUser } = useContext(UserContext);
  const [error, setError] = useState(null);

  const setUserContext = async (token) => {
    setError(null);
    return await axios
      .get(BASE_URL + "/auth/my_account/", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setUser(response.data);
        if (response.data.roles.some((role) => role?.code === "ADMIN")) {
          navigate({
            pathname: `/admin/teams`,
            state: { user: user },
          });
        } else if (
          response.data.roles.some((role) => role.code === "EXAM_CENTER_ADMIN")
        ) {
          navigate({
            pathname: `/admin/teams`,
            state: { user: user },
          });
        } else if (
          response.data.roles.some((role) => role.code === "SUPERVISOR")
        ) {
          navigate({
            pathname: `/my-team`,
            state: { user: user },
          });
        } else if (
          response.data.roles.some((role) => role.code === "STUDENT")
        ) {
          navigate({
            pathname: `/my-team`,
            state: { user: user },
          });
        } else {
          navigate({
            pathname: `/my-team`,
            state: { user: user },
          });
        }
      })
      .catch((err) => {
        setError(err.response.data);
      });
  };

  const loginUser = async (data) => {
    const { username, password } = data;

    return axios
      .post(BASE_URL + "/auth/login/", {
        username,
        password,
      })
      .then(async (response) => {
        TokenService.updateLocalAccessToken(response.data.access);
        bilAPI.defaults.headers["Authorization"] =
          "Bearer " + response.data.access;
        TokenService.updateLocalRefreshToken(response.data.refresh);

        await setUserContext(response.data.access);
      })
      .catch((err) => {
        setError(err.response);
      });
  };

  return {
    loginUser,
    setUserContext,
    error,
  };
}
